<template>
  <div>
    <Menu />

    <b-container class="py-2" :style="isMobile ? 'margin-bottom: 56px' : 'margin-top: 56px'">
      <slot />
    </b-container>

    <Toasts />
  </div>
</template>

<script>
import Menu from './Components/Menu'
import Toasts from './Components/Toasts'

export default {
  components: {
    Menu,
    Toasts,
  },
}
</script>

<style>
body {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
